import { createSlice } from '@reduxjs/toolkit';

const form = createSlice({
  name: 'form',
  initialState: {},
  reducers: {
    setNewErrorForm(state, action) {
      const { formName, errors } = action.payload;
      state = { ...state, [formName]: errors };
      return state;
    },
    setFieldErrorForm(state, action) {
      const { name, formName, error } = action.payload;
      state = { ...state, [formName]: { ...state[formName], [name]: error } };
      return state;
    },
    setFieldsErrorForm(state, action) {
      const { formName, errors } = action.payload;
      state = { ...state, [formName]: { ...state[formName], ...errors } };
      return state;
    },
    clearErrorForm(state, action) {
      const { formName } = action.payload;
      delete state[formName];
      return state;
    },
  },
});

export const { setNewErrorForm, setFieldErrorForm, setFieldsErrorForm, clearErrorForm } =
  form.actions;

export default form.reducer;
